import React, { FC, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import PAGES from "../../../../../constants/pages";
import { ICartItem, RootState, StepIndicatorType } from "../../../../../models";
import { trackCheckoutAndNavigate } from "../../../google-analytics";
import { selectors as LOADING_SELECTORS } from "../../../loading";
import BusinessDetailsForm from "../../components/organisms/BusinessDetailsForm/BusinessDetailsForm";
import CheckoutPage from "../../components/organisms/CheckoutPage/CheckoutPage";
import { usePrevious } from "../../hooks";
import { setBusinessDetails } from "../../state/actions/businessActions";
import { emptyOrder } from "../../state/actions/cartActions";
import * as BUSINESS_DETAILS_SELECTORS from "../../state/selectors/businessDetailsSelectors";
import { lastAddedCartItem as lastAddedCartItemSelector } from "../../state/selectors/cartSelectors";
import * as COMBINED_SELECTORS from "../../state/selectors/combinedSelectors";
import TEXT from "../../text-consts-b2b";

interface Props {
    // Redux (data)
    isFetchingData: boolean;
    isHardwareOnly: boolean;
    lastAddedCartItem: ICartItem;
    stepIndicator: StepIndicatorType;
    successfullySetBusinessDetails: boolean;
}

const B2BPersonalDetails: FC<Props> = ({
    // Redux
    isFetchingData,
    successfullySetBusinessDetails,
    isHardwareOnly,
    stepIndicator,
    lastAddedCartItem,
}) => {
    const dispatch = useDispatch();
    const prevSuccessfullySetBusinessDetails = usePrevious(successfullySetBusinessDetails);
    useEffect(() => {
        if (successfullySetBusinessDetails && successfullySetBusinessDetails !== prevSuccessfullySetBusinessDetails) {
            dispatch(trackCheckoutAndNavigate(1, PAGES.CHECKOUT_B2B.SUMMARY.URL));
        }
    }, [successfullySetBusinessDetails, prevSuccessfullySetBusinessDetails, trackCheckoutAndNavigate]);

    const location = useLocation();

    return (
        <CheckoutPage
            pageHeading={TEXT.PERSONAL_DETAILS.HEADING}
            isFetchingData={isFetchingData}
            isReadyToContinue={true}
            pageIndex={1}
            stepIndicator={stepIndicator}
            path={location.pathname}
            lastAddedCartItem={lastAddedCartItem}
            emptyOrder={() => dispatch(emptyOrder())}
        >
            {isHardwareOnly && <BusinessDetailsForm onSubmiteBusinessDetails={() => dispatch(setBusinessDetails())} />}
        </CheckoutPage>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        // Navigation
        stepIndicator: BUSINESS_DETAILS_SELECTORS.getStepIndicatorData(),

        // Loading
        isFetchingData: LOADING_SELECTORS.isLoading(state),

        // Cart
        lastAddedCartItem: lastAddedCartItemSelector(state),
        isHardwareOnly: COMBINED_SELECTORS.isHardwareOnly(state),

        // Business details
        successfullySetBusinessDetails: BUSINESS_DETAILS_SELECTORS.successfullySetBusinessDetails(state),
    };
};

export default connect(mapStateToProps)(B2BPersonalDetails);
